module.exports = __webpack_public_path__ + "static/img/toujiao13.7c04924.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toujiao13.jpg
// module id = 6nCr
// module chunks = 1